var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card-text", { staticClass: "black--text" }, [
    _c("h1", { staticClass: "mb-3" }, [_vm._v("COOKIES - MORE INFORMATION")]),
    _c("h3", [_vm._v("What is cookie?")]),
    _c("p", [
      _vm._v(
        "In HTTP protocol cookies, or cookie, is a text file – a small amount of data that servers send to a browser. The browser will save the data on the user’s computer. Each time the user visits webpages, the browser sends these data back to the server."
      )
    ]),
    _c("p", [
      _vm._v(
        'Cookies are commonly used to distinguish individual users. Typically, they store contents of a "shopping cart" in e-shop, user preferences and so on. Technically, these are series of codes that the browser collects and then sends back the information about user’s behaviour to the appropriate server. Cookies contain information about how long the browser should keep them (from one-time to several years).'
      )
    ]),
    _c("p", [
      _vm._v(
        "Cookies are not directly linked to your name or e-mail address, but often contain your system login information. They are common for one browser instance. Cookies are not secured by any means, including collected data."
      )
    ]),
    _c("h3", [_vm._v("What kind of cookies do we use?")]),
    _c("p", [
      _vm._v(
        "We use third-party cookies, namely Google Analytics for traffic analysis. These cookies are managed by third parties and we do not have access to read or write these data. You can learn more about Google Analytics Terms of Service "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
          }
        },
        [_vm._v("here")]
      ),
      _vm._v(".")
    ]),
    _c("h3", [_vm._v("What can you do?")]),
    _c("p", [
      _vm._v(
        "You can refuse or, if necessary, delete cookies. You will find instructions on how to do it in your web browser, section „Help“."
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }